import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { injectIntl } from 'react-intl-next';
import { N40 } from '@atlaskit/theme/colors';
import DownloadIcon from '@atlaskit/icon/glyph/download';
import Button from '@atlaskit/button/custom-theme-button';
import { messages } from '@atlaskit/media-ui';
// eslint-disable-next-line import/no-extraneous-dependencies

import { ANALYTICS_MEDIA_CHANNEL } from '../util';
const MediaDownloadButton = props => {
  const {
    onClick,
    intl: {
      formatMessage
    }
  } = props;
  return /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    testId: "download-button",
    iconAfter: /*#__PURE__*/React.createElement(DownloadIcon, {
      label: formatMessage(messages.download)
    }),
    onKeyPress: event => event.stopPropagation(),
    onClick: (event, analyticsEvent) => {
      analyticsEvent.update(payload => ({
        ...payload,
        eventType: 'ui',
        actionSubjectId: 'mediaTableDownload'
      })).fire(ANALYTICS_MEDIA_CHANNEL);
      onClick(event);
    },
    theme: (current, themeProps) => ({
      buttonStyles: {
        ...current(themeProps).buttonStyles,
        minWidth: 'max-content',
        '&:hover': {
          background: `var(--ds-background-neutral-hovered, ${N40})`
        }
      },
      spinnerStyles: current(themeProps).spinnerStyles
    })
  });
};
export default injectIntl(MediaDownloadButton);